import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FreightFixture } from './freight-fixture.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FreightFixtureService {
  private apiUrl = `${environment.applicationApi}/messages/freight-fixtures`;

  constructor(private http: HttpClient) { }

  getFreightFixtures(startDate?: Date, endDate?: Date): Observable<FreightFixture[]> {
    let params = new HttpParams();
    
    if (startDate) {
      params = params.set('startDate', startDate.toISOString());
    }
    if (endDate) {
      params = params.set('endDate', endDate.toISOString());
    }

    return this.http.get<FreightFixture[]>(this.apiUrl, { params });
  }
}

